import React from 'react'
import styles from './AuditInfoPanel.module.css'

interface ExamplesControlsProps {
  isLoadingFailedExamples: boolean
  lookupAuditId: string
  setLookupAuditId: (id: string) => void
  isLoadingLookup: boolean
  onFetchFailedExamples: () => void
  onLookupAudit: () => void
}

function ExamplesControls({
  isLoadingFailedExamples,
  lookupAuditId,
  setLookupAuditId,
  isLoadingLookup,
  onFetchFailedExamples,
  onLookupAudit,
}: ExamplesControlsProps) {
  return (
    <div className={styles.examplesSection}>
      <h3 className={styles.sectionLabel}>Examples</h3>
      <div className={styles.examplesControls}>
        <button
          className={styles.seeFailedExamplesButton}
          onClick={onFetchFailedExamples}
          disabled={isLoadingFailedExamples}
        >
          {isLoadingFailedExamples ? 'Loading...' : 'See Failed Examples'}
        </button>
        <div className={styles.lookupAuditControls}>
          <input
            type='text'
            className={styles.lookupAuditInput}
            value={lookupAuditId}
            onChange={(e) => setLookupAuditId(e.target.value)}
            placeholder='Enter Audit ID'
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                onLookupAudit()
              }
            }}
          />
          <button
            className={styles.lookupAuditButton}
            onClick={onLookupAudit}
            disabled={isLoadingLookup || !lookupAuditId.trim()}
          >
            {isLoadingLookup ? 'Loading...' : 'Lookup'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ExamplesControls
